<ng-container *ngrxLet="businessPlan$ as businessPlan">
  <section
    *ngIf="visible && orderId && businessPlan?.isPremium()"
    class="flex items-center gap-2 min-h-[80px]"
  >
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        clip-rule="evenodd"
        d="M14.25 6H13.845C14.1094 5.54424 14.2491 5.02689 14.25 4.5C14.25 3.25736 13.2426 2.25 12 2.25C10.7829 2.39897 9.68941 3.06602 9 4.08C8.31059 3.06602 7.21706 2.39897 6 2.25C4.75736 2.25 3.75 3.25736 3.75 4.5C3.75093 5.02689 3.89062 5.54424 4.155 6H3.75C2.92157 6 2.25 6.67157 2.25 7.5V9.75C2.25 10.1642 2.58579 10.5 3 10.5H3.75V14.25C3.75 15.0784 4.42157 15.75 5.25 15.75H12.75C13.5784 15.75 14.25 15.0784 14.25 14.25V10.5H15C15.4142 10.5 15.75 10.1642 15.75 9.75V7.5C15.75 6.67157 15.0784 6 14.25 6ZM12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5C12.7508 4.99894 12.5034 5.46559 12.09 5.745C11.8417 5.91186 11.5492 6.00067 11.25 6H9.75C9.75 5.1825 11.1825 3.75 12 3.75ZM6 3.75C5.58579 3.75 5.25 4.08579 5.25 4.5C5.25 5.32843 5.92157 6 6.75 6H8.25C8.25 5.1825 6.8175 3.75 6 3.75ZM8.25 7.5V9H3.75V7.5H8.25ZM8.25 14.25V10.5H5.25V14.25H8.25ZM9.75 14.25V10.5H12.75V14.25H9.75ZM9.75 7.5V9H14.25V7.5H9.75Z"
        fill="#00A3FF"
        fill-rule="evenodd"
      />
    </svg>

    <span
      (click)="showPromoCode()"
      (keydown.enter)="showPromoCode()"
      (keydown.space)="showPromoCode()"
      class="cursor-pointer text-[#00A3FF]"
    >
      I have a promo code
    </span>

    <ng-container *ngIf="promoCodeVisible">
      <form (ngSubmit)="applyPromoCode()" [formGroup]="promoCodeForm">
        <mat-form-field appearance="outline" class="ml-6 w-60">
          <mat-label>Input code here</mat-label>
          <input
            #promoCodeInput
            (keydown.enter)="applyPromoCode(); $event.preventDefault()"
            formControlName="promoCode"
            matInput
            placeholder="Input code here"
            type="text"
          >
          <button
            (click)="promoCodeForm.controls.promoCode.setValue('')"
            *ngIf="promoCodeForm.controls.promoCode.value"
            aria-label="Clear"
            mat-icon-button
            matSuffix
            type="button"
          >
            <mat-icon>highlight_off</mat-icon>
          </button>
        </mat-form-field>
      </form>

      <button (click)="applyPromoCode()" class="!ml-2" color="primary" mat-flat-button type="submit">
        Apply
      </button>

      <ng-container *ngIf="promotionApplicationCheckResult?.isValid">
        <button (click)="removePromoCode()" class="!ml-2" color="warn" mat-flat-button>
          Remove
        </button>
      </ng-container>

      <ng-container *ngIf="isCheckingPromo; else validationMessages">
        <div class="ml-4 inline-flex text-[#00A3FF]">
          <mat-icon class="spin">autorenew</mat-icon>
          <span class="ml-1 inline-block">Checking promo code...</span>
        </div>
      </ng-container>

      <ng-template #validationMessages>
        <ng-container *ngIf="promotionApplicationCheckResult?.type && !promotionApplicationCheckResult?.isValid">
          <div class="ml-4 inline-flex text-[#F44336]">
            <mat-icon>error_outline</mat-icon>
            <span class="ml-1 inline-block">{{ promotionApplicationCheckResult?.message }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="promotionApplicationCheckResult?.isValid">
          <div class="ml-4 inline-flex text-[#19C20A]">
            <mat-icon>check_circle_outline</mat-icon>
            <span class="ml-1 inline-block">{{ promotionApplicationCheckResult?.message }}</span>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
  </section>
</ng-container>
